import withActivableRenderer from 'src/hocs/withActivableRenderer';
import Notification from './Notification';

export default withActivableRenderer()(Notification);
